export const createRipple = (event: React.MouseEvent<HTMLElement>) => {
    const button = event.currentTarget;

    const circle = document.createElement("span");
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;

    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${event.clientX - button.getBoundingClientRect().left - radius}px`;
    circle.style.top = `${event.clientY - button.getBoundingClientRect().top - radius}px`;
    circle.style.position = "absolute";
    circle.style.borderRadius = "50%";
    circle.style.backgroundColor = "rgba(0, 0, 0, 0.15)";
    circle.style.transform = "scale(0)";
    circle.style.animation = "ripple 500ms linear";
    circle.style.pointerEvents = "none";

    const rippleOld = button.getElementsByClassName("ripple")[0];
    if (rippleOld) rippleOld.remove();

    circle.classList.add("ripple");
    button.appendChild(circle);

    setTimeout(() => {
        circle.remove();
    }, 500);
};
